export const chartWrapper = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '250px',
}

export const tooltipStyles = {
  backgroundColor: '#fff',
  border: '1px solid #ccc',
  borderRadius: '5px',
}

export const tooltipLabelStyles = {
  fontSize: '14px',
  color: '#000000',
}
